import { SET_ALL_CYCLE_COUNT_ITEMS } from './actionType'

export function setAllCycleCountItems(allCycleCountItems) {
  return {
    type: SET_ALL_CYCLE_COUNT_ITEMS,
    allCycleCountItems: allCycleCountItems,
  }
}
